
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import Business, { BusinessProxy } from '../models/Business';
import SectorAndCategory from '../components/SectorAndCategroy.vue';

@Component({ components: { MediaImg, SectorAndCategory } })
export default class BusinessTile extends Vue {
  @Prop(String) readonly slug!: string;

  @Prop(Object) readonly business!: Business;

  hover = false;

  dataPromise = new ObservedPromise<BusinessProxy>();

  get item(): Business | undefined {
    return this.business || this.dataPromise.value?.data || undefined;
  }

  get url(): string {
    if (!this.item) {
      return '';
    }
    return `/business/${this.item.slug}`;
  }

  get elevation(): number {
    return this.hover ? 10 : 0;
  }

  @Watch('slug', { immediate: true })
  onSlugChanged(slug: string | undefined) {
    if (slug && !this.business) {
      const promise = Business.where({ slug })
        // .includes('category')
        .first();
      this.dataPromise = new ObservedPromise(promise);
    } else {
      this.dataPromise = new ObservedPromise();
    }
  }
}
